export const BASE_API_URL = 'https://api.emoha.com/api/v1';
// export const BASE_API_URL = 'https://api.emoha.squareboat.info/api/v1/';
export const RESPONDER_DETAILS = '/responder/:id/kyc';
export const RESPONDER_QUEUE = '/responder/kyc/queue';

export const GET_NAME = 'admin/public-elder/:id';
export const TNC_SUBMIT = 'admin/update-term-condition-time/:id';
